import { Maybe, User } from '../../common/types'
import { ArcCodeLists } from '../../components/ALSubForm/types'

export interface IState {
  currentUser: Maybe<User>
  offlineMode: boolean
  unSavedJobCount: number
  AlArcCodes: ArcCodeLists
  showMessages: boolean
  messageCount: number
}


export enum ActionTypes {
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  SET_OFFLINE_MODE = 'SET_OFFLINE_MODE',
  SET_UN_SAVED_JOB_COUNT = 'SET_UN_SAVED_JOB_COUNT',
  SHOW_SOCKET_MESSAGES = 'SHOW_SOCKET_MESSAGES',
  HIDE_SOCKET_MESSAGES = 'HIDE_SOCKET_MESSAGES',
  SET_MESSAGE_COUNT = 'SET_MESSAGE_COUNT',
}

export type Action =
  | SetCurrentUserAction
  | SetOfflineModeAction
  | SetUnSavedJobCount
  | ShowSocketMessages
  | HideSocketMessages
  | SetMessageCount

export interface SetCurrentUserAction {
  type: ActionTypes.SET_CURRENT_USER
  value: User
}



export interface SetOfflineModeAction {
  type: ActionTypes.SET_OFFLINE_MODE
  value: boolean
}

export interface SetUnSavedJobCount {
  type: ActionTypes.SET_UN_SAVED_JOB_COUNT
  value: number
}
export interface ShowSocketMessages {
  type: ActionTypes.SHOW_SOCKET_MESSAGES
  value: boolean
}
export interface HideSocketMessages {
  type: ActionTypes.HIDE_SOCKET_MESSAGES
  value: boolean
}
export interface SetMessageCount {
  type: ActionTypes.SET_MESSAGE_COUNT
  value: number
}


export type IContext = IStateContext & IDispatchContext

export interface IStateContext {
  state: IState
}

export interface IDispatchContext {
  dispatch: React.Dispatch<Action>
}
